import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import showToast from "../../../services/toast";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { AlertLoadingHeader } from "../../../components/alertLoadingComponent/alertLoading";
import React from "react";
import PagesHeader from "ah_utility/PagesHeader";
import { useStepNavigation } from "ah_utility/NavigationEngine";
export var PaymentHeader = function (props) {
    var _a;
    var t = useTranslation().t;
    var pathname = useLocation().pathname;
    var isLastPage = useStepNavigation({ currentStepId: pathname }).isLastPage;
    return (_jsxs(_Fragment, { children: [_jsx(AlertLoadingHeader, { loading: props.loadingCreatePolicy || props.loading, seeToast: props.seeToast, showToast: showToast, setSeeToast: props.setSeeToast, titleLoading: props.loadingCreatePolicy ? "Generando pago" : "Cargando datos" }), _jsx(PagesHeader, { titlePage: "Confirmación de pago", hideStep: (_a = props.hideStep) !== null && _a !== void 0 ? _a : false, steps: props.steps, completed: isLastPage })] }));
};
